import { PageHeader } from "@layouts/PageHeader";
import { ColumnTabs } from "@src/ui/ColumnTabs";
import { Content } from "@src/ui/Content";
import { useState } from "react";
import { ButtonExample } from "./ButtonExample";

const options = [{ label: "Button", value: "Button", component: <ButtonExample></ButtonExample> }];

export const PageTheme = () => {
  const [tab, setTab] = useState<string>("Basic");
  const current = options.find((option) => option.value === tab);
  return (
    <div>
      <PageHeader></PageHeader>
      <div className="w-[1190px] py-[24px] mx-auto flex flex-row gap-[16px] h-[calc(100vh-53px)]">
        <div className="w-[218px]">
          <ColumnTabs options={options} value={tab} onChange={setTab}></ColumnTabs>
        </div>
        <Content className="flex-1 overflow-y-auto">
          <Content.Title>{current?.label}</Content.Title>
          {current?.component}
        </Content>
      </div>
    </div>
  );
};
